export const top = '/';
export const login = '/login';
export const logout = '/logout';
export const reservation = '/reservation';
export const driveList = '/drive-list';
export const driveDetails = '/drive-details';
export const menu = '/menu';
export const notification = '/notification';
export const vehicleDriverUpdate = '/vehicle-driver/update';
export const vehicleDriverSelect = '/vehicle-driver/select';
export const operationFinishConfirm = '/operation-finish-confirm';
export const offering = '/offering';
export const waypointConfirm = '/waypoint-confirm';
export const driveRoutes = '/drive-routes';

// サンプル
export const buttons = '/buttons';
export const dialogs = '/dialogs';
export const forms = '/forms';
